import { LogType } from '@infodata-group/inf-commons';
import dayjs from 'dayjs';

export class CustomLog {
  public date: Date;
  public type: LogType;
  public data: unknown;

  public static getType(data: string | Error | Object): LogType {
    if (data instanceof Error) {
      return LogType.error;
    }
    return LogType.verbose;
  }

  constructor(data: unknown, type: LogType) {
    this.date = new Date();
    this.type = type;
    this.data = data;
  }

  public toString(): string {
    return `${dayjs(this.date).format('HH:mm:SSS')} [${this.type}]`;
  }

  console() {
    switch (this.type) {
      case LogType.error:
        console.error(this.toString(), this.data);
        break;
      case LogType.warning:
        console.warn(this.toString(), this.data);
        break;
      default:
        console.log(this.toString(), this.data);
    }
  }
}
